export const issues = {
  not_transferred_amount: 'Перевел(-а) не ту сумму',
  multiple_transfers: 'Сделал(-а) перевод несколькими платежами',
  not_transferred_bank: 'Перевел(-а) не в тот банк',
  other: 'Другое',
} as const;
